export default "__VITE_ASSET__Dy3Z8TBv__"